module.exports = __webpack_public_path__ + "img/loading.3f412520.png";